module.exports = __webpack_public_path__ + "static/media/solar_state_diagram.747209dd.jpg";